import { render, staticRenderFns } from "./InboxOrder.vue?vue&type=template&id=8f83eaa8&scoped=true&lang=pug&"
import script from "./InboxOrder.vue?vue&type=script&lang=js&"
export * from "./InboxOrder.vue?vue&type=script&lang=js&"
import style0 from "./InboxOrder.vue?vue&type=style&index=0&id=8f83eaa8&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f83eaa8",
  null
  
)

export default component.exports